/**
 * Phase 32 Plan 32-2 — project ↔ repository mapping frontend API client.
 *
 * Endpoints:
 *   GET    /api/projects/:projectId/repositories
 *   POST   /api/projects/:projectId/repositories       body { githubRepositoryId }
 *   DELETE /api/projects/:projectId/repositories/:githubRepositoryId
 *   GET    /api/projects/repositories/available
 */
import { apiDelete, apiGet, apiPost } from './client';

export interface GithubRepository {
  id: string; // BigInt serialised as string
  owner: string;
  name: string;
  defaultBranch: string;
  archived: boolean;
  isFork: boolean;
  ingestEnabled: boolean;
  discoveredAt: string; // ISO 8601
  lastIngestedAt: string | null;
}

export interface ProjectRepository {
  projectId: number;
  repository: GithubRepository;
  createdAt: string; // ISO 8601
}

export async function fetchProjectRepositories(projectId: number): Promise<ProjectRepository[]> {
  const res = await apiGet<{ data: ProjectRepository[] }>(`/projects/${projectId}/repositories`);
  return res.data;
}

export async function fetchAvailableRepositories(): Promise<GithubRepository[]> {
  const res = await apiGet<{ data: GithubRepository[] }>(`/projects/repositories/available`);
  return res.data;
}

export async function linkRepository(
  projectId: number,
  githubRepositoryId: string,
): Promise<void> {
  await apiPost<{ data: { success: boolean } }>(`/projects/${projectId}/repositories`, {
    githubRepositoryId,
  });
}

export async function unlinkRepository(
  projectId: number,
  githubRepositoryId: string,
): Promise<void> {
  await apiDelete<{ data: { success: boolean } }>(
    `/projects/${projectId}/repositories/${githubRepositoryId}`,
  );
}
